import type { ComputedRef, InjectionKey, VNodeChild } from 'vue'

export interface ImagePreviewOptions {
  visible?: boolean
  current?: number
  src?: string
  maskClassName?: string
  getContainer?: string | HTMLElement | (() => HTMLElement)
  onVisibleChange?: (visible: boolean, previousVisible: boolean) => void
}
export interface PreviewImage { src: string; alt: string }
export interface ImageGroupContext {
  enabled: ComputedRef<boolean>
  register: (id: string, image: () => PreviewImage) => () => void
  open: (id: string) => void
}
export interface ImageProps {
  src?: string
  alt?: string
  width?: string | number
  height?: string | number
  fallback?: string
  preview?: boolean | ImagePreviewOptions
  previewMask?: boolean | VNodeChild
  placeholder?: boolean
}
export const imageGroupKey: InjectionKey<ImageGroupContext> = Symbol('rrImagePreviewGroup')
